
//Valentine's Offer text direct static replacement

// (function () {
//   var OLD_TEXTS = [
//     "🥳 アニバーサリーセール開催中！🥳",
//     "🥳 Our Anniversary Sale Is On! 🥳"
//   ];
//  // var NEW_TEXT = "❤️ バレンタインセール開催中！❤️";
// //  var NEW_TEXT = "イースターセールを絶賛開催中です 🐰🐣";
// // var NEW_TEXT = "🕵️ ミステリー5月セール、ついにスタート！ 🕵️";
// //  var NEW_TEXT = "🤸🎈プレイデイズセール開催中 🎈👩🏼‍🤝‍👨🏽";
//   var NEW_TEXT = "🎒✨ スマートスタートセール、開催中 ✨📚👩🏼‍🤝‍👨🏽";

//   function replaceText(root) {
//     var scope = root || document;

//     scope
//       .querySelectorAll("h1,h2,h3,h4,h5,h6,#seasonalSale")
//       .forEach(function (el) {
//         if (OLD_TEXTS.includes(el.textContent.trim())) {
//           el.textContent = NEW_TEXT;
//         }
//       });
//   }

//   replaceText();

//   if (window.MutationObserver) {
//     new MutationObserver(function (mutations) {
//       mutations.forEach(function (m) {
//         if (m.type === "childList" || m.type === "characterData") {
//           replaceText(m.target.nodeType === 1 ? m.target : m.target.parentNode);
//         }
//       });
//     }).observe(document.body, {
//       childList: true,
//       subtree: true,
//       characterData: true
//     });
//   }
// })();

(function () {
  var currentDate = new Date();
  var year = currentDate.getFullYear();

  // Active period: October 19 to October 25 (inclusive)
  var startDate = new Date(year, 9, 19, 0, 0, 0);
  var endDate = new Date(year, 9, 26, 0, 0, 0);

  // Stop completely outside the active period
  if (currentDate < startDate || currentDate >= endDate) {
    return;
  }

  var OLD_TEXTS = [
     "🥳 アニバーサリーセール開催中！🥳",
    "🥳 Our Anniversary Sale Is On! 🥳"
  ];

  var NEW_TEXT =
    "🤸🎈 ビッグ・キッズ・セール がついにスタート！ 🎈👩🏼‍🤝‍👨🏽";

  function replaceText(root) {
    var scope = root || document;

    if (scope.nodeType === 1 &&
        scope.matches("h1,h2,h3,h4,h5,h6,#seasonalSale") &&
        OLD_TEXTS.includes(scope.textContent.trim())) {
      scope.textContent = NEW_TEXT;
    }

    if (scope.querySelectorAll) {
      scope
        .querySelectorAll("h1,h2,h3,h4,h5,h6,#seasonalSale")
        .forEach(function (el) {
          if (OLD_TEXTS.includes(el.textContent.trim())) {
            el.textContent = NEW_TEXT;
          }
        });
    }
  }

  replaceText();

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === "childList" || m.type === "characterData") {
          var target =
            m.target.nodeType === 1
              ? m.target
              : m.target.parentNode;

          if (target) {
            replaceText(target);
          }
        }
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
})();



// (function() {

//   var NEW_HEADING_TEXT = "🎄 クリスマスセールがついにスタート！🎅";
// var NEW_HEADING_HTML = '🎄 <span class="black-friday-allproducts">クリスマス</span>セールがついにスタート！🎅';


//   // var NEW_HEADING_TEXT = "🎉 サイバーマンデーセールです！🥳";
//   // var NEW_HEADING_HTML = '🎉 <span class="black-friday-allproducts">サイバーマンデー</span>セールです！🥳';

//   function replaceAnniversaryHeadings(root) {
//     var headings = (root || document).querySelectorAll("h1,h2,h3,h4,h5,h6");

//     headings.forEach(function(h) {
//       var txt = (h.textContent || "").trim();
//       if (!txt) return;

//       if (
//         txt.includes("アニバーサリーセール") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (
//         (txt.includes("本日") || txt.includes("今日")) &&
//         txt.includes("記念日") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         var idx = txt.indexOf("記念日");
//         var prefix = txt.slice(0, idx);
//         prefix = prefix.replace(/[、,\s]+$/u, "");
//         //var newText = prefix + 'は <span class="black-friday-allproducts">サイバーマンデー</span>セールです！🥳';
//          var newText = prefix + 'は <span class="black-friday-allproducts">クリスマス</span>セールです！🎅';

//         newText = newText.replace(/🎉/g, "🎄").replace(/🥳/g, "🎅");
        
//         h.innerHTML = newText;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (txt === NEW_HEADING_TEXT && !h.querySelector(".black-friday-allproducts")) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//       }
//     });
//   }

//   function startReplacing() {
//     replaceAnniversaryHeadings(document);

//     var attempts = 0;
//     var intervalId = setInterval(function() {
//       replaceAnniversaryHeadings(document);
//       if (++attempts > 30) clearInterval(intervalId);
//     }, 500);

//     if (window.MutationObserver) {
//       new MutationObserver(function(mutations) {
//         mutations.forEach(function(m) {
//           m.addedNodes.forEach(function(node) {
//             if (node.nodeType === 1) replaceAnniversaryHeadings(node);
//           });
//         });
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", startReplacing);
//   } else {
//     startReplacing();
//   }

// })();

